import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IUserTypes, useUserModel } from "../userModel";
import { IUserDetial } from "../userType";
import useNavModel from "@/model/navModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
        setIVisibleDrawer, removeUser,
        setSelectedRow,
        tabActive
    } = useUserModel();
    const { addNav, replaceNav } = useNavModel(() => []);
    const onEdit = (record: IUserDetial) => {
        setSelectedRow(record)
        setIVisibleDrawer("edit")
        setSelectedRowKeys([record.id as string])
    }

    const columns: ColumnsType<IUserDetial> = [
        {
            title: '序号',
            width: 80,
            render: (text, record, index) => `${index + 1}`,
            fixed: "left"
        }, {
            title: '员工账户',
            width: 130,
            dataIndex: 'account',
        }, {
            title: `${tabActive === IUserTypes.USER ? "用户" : "厨师"}姓名`,
            width: 130,
            dataIndex: 'name'
        },
        tabActive === IUserTypes.USER ? {
            title: '个人积分',
            width: 130,
            dataIndex: 'pointNum',
            align: "center",
            render: (text, r) => <span style={{ color: "blue", cursor: "pointer" }} onClick={() => replaceNav("6", "6-1", { mode: "add", id: r.id as string }, true)}>{text}</span>
        } : {
            title: '星级评分',
            width: 130,
            dataIndex: 'grade',
            align: "center",
            render: (text, r) => <span style={{ color: "blue", cursor: "pointer" }} onClick={() => replaceNav("6", "6-2", { mode: "add", id: r.id as string }, true)}>{text}</span>
        },
        {
            title: '联系电话',
            width: 130,
            dataIndex: 'phone',
        }, {
            title: '所属机构',
            width: 130,
            dataIndex: 'branchName',
        }, {
            title: '操作',
            width: 130,
            dataIndex: 'phone',
            render: (text, record) => <div>
                <span className="click-span" onClick={() => onEdit(record)}>编辑</span>
                <span className="click-span" onClick={() => removeUser(record.id as string)}>删除</span>
            </div>
        }
    ];


    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id as string]);
        }
    };

    return (
        <Table
            loading={loading}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IUserDetial[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
